export default __webpack_public_path__ + "static/media/ic_GiftCard.e2e209e4.svg";